import { createPortal } from 'react-dom';
import Loader from '../../images/loader.gif';

import './page-loader.scss';


export const PageLoader: React.FC = () => {
    const parentElement = document.body;

    return createPortal(
        (
            <div className="page-loader">
                <div className="page-loader-overlay"></div>
                <img className="page-loader-img" src={Loader} alt="" />
            </div>
        ),
        parentElement
    );
}